// extracted by mini-css-extract-plugin
module.exports = {"root":"AdditionalInfo_root__XEt4B","rows":"AdditionalInfo_rows__C_DG4","row":"AdditionalInfo_row__lILV4","tooltip":"AdditionalInfo_tooltip__vQl2X"};